import React from 'react';

import type { ReadingStatProps } from '@hooks/useBlueConicPersonalizedReadingHub';

import MyTIReadingStat from './ReadingStat';

const MyTIReadingStats = ({
  articlesRead,
  minutesRead,
  mostReadTopic,
  mostReadNewsletter,
}: ReadingStatProps) => {
  return (
    <article className="items-between relative mt-48 flex flex-col justify-center gap-32 sm:flex-row sm:flex-wrap md:flex-nowrap lg:gap-64">
      <MyTIReadingStat index={0} name="Articles Read" value={articlesRead} />
      <MyTIReadingStat index={1} name="Reading Time" value={`${minutesRead} mins`} />
      <MyTIReadingStat index={2} name="Most-read Topic" value={mostReadTopic} small />
      <MyTIReadingStat index={3} name="Most-read Newsletter" value={mostReadNewsletter} small />
    </article>
  );
};

export default MyTIReadingStats;
